(() => {
  const formSelector = 'form.newsletter-ajax-form, form[data-newsletter-ajax]';
  const confirmationParam = 'newsletter_confirmation';

  function confirmationFor(form) {
    const token = window.crypto?.randomUUID?.()
      || `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
    const returnUrl = new URL(window.location.href);
    returnUrl.searchParams.delete('customer_posted');
    returnUrl.searchParams.set(confirmationParam, token);
    returnUrl.hash = form.id || '';
    return {
      token,
      returnTo: `${returnUrl.pathname}${returnUrl.search}${returnUrl.hash}`
    };
  }

  function isConfirmedUrl(url, token) {
    return url.searchParams.get('customer_posted') === 'true'
      || url.searchParams.get(confirmationParam) === token;
  }

  function message(form, name) {
    const config = form.querySelector('[data-newsletter-config]');
    return form.dataset[name] || config?.dataset[name] || '';
  }

  function setLoading(form, loading) {
    form.dataset.newsletterBusy = String(loading);
    form.setAttribute('aria-busy', String(loading));

    for (const button of form.querySelectorAll('[type="submit"]')) {
      if (loading) {
        if (button.dataset.newsletterWasDisabled == null) {
          button.dataset.newsletterWasDisabled = String(button.disabled);
        }
        button.disabled = true;
      } else {
        button.disabled = button.dataset.newsletterWasDisabled === 'true';
        delete button.dataset.newsletterWasDisabled;
      }
      button.classList.toggle('is--loading', loading);

      if (button.matches('.subscribe-submit')) {
        const label = button.querySelector('span');
        if (!label) continue;
        if (loading) {
          if (label.dataset.originalText == null) label.dataset.originalText = label.textContent;
          label.textContent = message(form, 'newsletterLoading');
        } else if (label.dataset.originalText) {
          label.textContent = label.dataset.originalText;
          delete label.dataset.originalText;
        }
      }
    }
  }

  function responseContainer(form) {
    let container = form.querySelector('[data-new-response-form], [data-newsletter-ajax-response]');
    if (container) return container;

    container = document.createElement('div');
    container.dataset.newsletterAjaxResponse = '';
    form.append(container);
    return container;
  }

  function showMessage(form, state, message) {
    const container = responseContainer(form);
    const notice = document.createElement('div');
    const isSuccess = state === 'success';

    container.replaceChildren(notice);
    container.hidden = false;
    notice.className = form.classList.contains('subscribe-form')
      ? `subscribe-${state}`
      : `t4s-newsletter__${state}`;
    notice.setAttribute('role', state === 'error' ? 'alert' : 'status');
    notice.setAttribute('aria-live', state === 'error' ? 'assertive' : 'polite');
    notice.textContent = message;

    if (state === 'verification') {
      notice.style.color = '#ffffff';
      notice.style.background = 'rgba(255, 255, 255, 0.1)';
      notice.style.border = '1px solid rgba(255, 255, 255, 0.35)';
      notice.style.borderRadius = '6px';
      notice.style.padding = '10px 12px';
      notice.style.marginTop = '10px';
    }

    form.dataset.newsletterState = state;
    if (isSuccess) {
      const fields = form.querySelector('.subscribe-field, .t4s-newsletter__fields');
      if (fields) {
        fields.hidden = true;
        fields.style.display = 'none';
      }
    }
  }

  function clearLegacyFormState() {
    try {
      window.localStorage.removeItem('t4s-recentform');
    } catch (_) {
      // Storage can be unavailable when privacy settings block it.
    }
  }

  function rememberNewsletterPopup(attempt = 0) {
    const popup = document.querySelector('#t4s-popup__newsletter');
    if (!popup) {
      if (attempt < 2) window.setTimeout(() => rememberNewsletterPopup(attempt + 1), 1000);
      return;
    }

    try {
      const settings = JSON.parse(popup.dataset.stt || '{}');
      const themeName = window.T4Sconfigs?.theme;
      if (!window.CookiesT4 || !themeName || settings.pp_version == null) return;

      window.CookiesT4.set(`${themeName}_newsletter${settings.pp_version}`, 'shown', {
        expires: Number.parseInt(settings.day_next, 10) || 0,
        path: '/'
      });
    } catch (_) {
      // A malformed popup configuration must not break newsletter feedback.
    }
  }

  function announceSuccess(form) {
    rememberNewsletterPopup();
    form.dispatchEvent(new CustomEvent('newsletter:success', {bubbles: true}));
  }

  function requestVerification(form, url, confirmationToken) {
    showMessage(form, 'verification', message(form, 'newsletterVerification'));
    const link = document.createElement('a');
    link.href = url.href;
    link.textContent = message(form, 'newsletterVerify');
    link.style.textDecoration = 'underline';
    link.style.color = '#ffffff';
    link.style.display = 'inline-block';
    link.style.fontWeight = '600';
    link.style.marginTop = '6px';
    responseContainer(form).append(link);
    link.addEventListener('click', event => {
      if (form.dataset.newsletterBusy === 'true') {
        event.preventDefault();
        return;
      }
      const popup = window.open(url.href, '_blank', 'popup,width=600,height=760');
      if (!popup) return;
      event.preventDefault();
      setLoading(form, true);
      const deadline = Date.now() + 300000;
      const check = () => {
        if (popup.closed || Date.now() >= deadline || !form.isConnected) {
          setLoading(form, false);
          return;
        }
        try {
          const location = new URL(popup.location.href);
          if (location.origin === window.location.origin && isConfirmedUrl(location, confirmationToken)) {
            showMessage(form, 'success', message(form, 'newsletterSuccess'));
            announceSuccess(form);
            setLoading(form, false);
            popup.close();
            return;
          }
        } catch (_) {
          // Verification can temporarily redirect through another origin.
        }
        window.setTimeout(check, 500);
      };
      check();
    });
  }

  function restoreConfirmedSubmission() {
    const location = new URL(window.location.href);
    if (location.searchParams.get('customer_posted') !== 'true' && !location.searchParams.has(confirmationParam)) return;

    let form = null;
    if (location.hash) {
      try {
        const target = document.querySelector(location.hash);
        if (target instanceof HTMLFormElement && target.matches(formSelector)) form = target;
      } catch (_) {
        form = null;
      }
    }
    if (!form) form = document.querySelector(formSelector);
    if (!form) return;

    showMessage(form, 'success', message(form, 'newsletterSuccess'));
    announceSuccess(form);
    setLoading(form, false);
  }

  async function submitNewsletter(form) {
    const confirmation = confirmationFor(form);
    const transport = document.createElement('form');
    transport.method = 'post';
    transport.action = form.action;
    transport.hidden = true;
    transport.addEventListener('submit', event => event.preventDefault());
    const excluded = new Set(['h-captcha-response', 'g-recaptcha-response', 'recaptcha-v3-token', 'form_key', 'return_to']);
    for (const [name, value] of new FormData(form)) {
      if (!excluded.has(name) && typeof value === 'string') {
        transport.append(Object.assign(document.createElement('input'), {type: 'hidden', name, value}));
      }
    }
    transport.append(Object.assign(document.createElement('input'), {
      type: 'hidden',
      name: 'return_to',
      value: confirmation.returnTo
    }));
    const controller = new AbortController();
    let active = true;
    let sent = false;
    let protectionTimeout;
    let requestTimeout;
    let poll;
    setLoading(form, true);
    responseContainer(form).replaceChildren();
    delete form.dataset.newsletterState;
    clearLegacyFormState();

    try {
      const response = await new Promise((resolve, reject) => {
        protectionTimeout = window.setTimeout(() => {
          active = false;
          reject(new Error('Shopify form protection did not load'));
        }, 10000);

        transport.submit = () => {
          if (!active || sent) return;
          if (!transport.elements['h-captcha-response']?.value || !transport.elements.form_key?.value) {
            reject(new Error('Shopify form protection is incomplete'));
            return;
          }
          sent = true;
          requestTimeout = window.setTimeout(() => {
            active = false;
            controller.abort();
            reject(new Error('Newsletter submission could not be confirmed'));
          }, 60000);
          fetch(transport.action, {
            method: 'POST',
            credentials: 'same-origin',
            cache: 'no-store',
            body: new URLSearchParams(new FormData(transport)),
            signal: controller.signal
          }).then(resolve, reject);
        };
        document.body.append(transport);

        const protect = () => {
          if (!active) return;
          if (!window.Shopify?.captcha?.protect) {
            poll = window.setTimeout(protect, 100);
            return;
          }
          window.clearTimeout(protectionTimeout);
          try {
            window.Shopify.captcha.protect(transport, () => {
              if (active) transport.requestSubmit();
            });
          } catch (error) {
            reject(error);
          }
        };
        protect();
      });

      const responseUrl = new URL(response.url, window.location.href);
      if (responseUrl.origin !== window.location.origin) throw new Error('Unexpected subscription response');
      if (/\/challenge\/?$/.test(responseUrl.pathname)) {
        requestVerification(form, responseUrl, confirmation.token);
      } else if (response.ok && isConfirmedUrl(responseUrl, confirmation.token)) {
        showMessage(form, 'success', message(form, 'newsletterSuccess'));
        announceSuccess(form);
      } else {
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const returnedForm = form.id ? html.getElementById(form.id) : null;
        const error = returnedForm?.querySelector('.subscribe-error, .t4s-newsletter__error, .errors');
        showMessage(form, 'error', error?.textContent.trim() || message(form, 'newsletterError'));
      }
    } catch (_) {
      showMessage(form, 'error', message(form, 'newsletterError'));
    } finally {
      active = false;
      window.clearTimeout(protectionTimeout);
      window.clearTimeout(requestTimeout);
      window.clearTimeout(poll);
      transport.remove();
      clearLegacyFormState();
      setLoading(form, false);
    }
  }

  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches(formSelector)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.newsletterBusy === 'true' || form.dataset.newsletterState === 'success') return;
    if (form.reportValidity()) submitNewsletter(form);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreConfirmedSubmission, {once: true});
  } else {
    restoreConfirmedSubmission();
  }
})();
